export default "__VITE_PUBLIC_ASSET__99c88498__"